module.exports = __webpack_public_path__ + "img/feature-item-02.9cd9a609.png";